export default "__VITE_ASSET__BPdlOrWN__"